import * as React from 'react';
import { connect } from 'react-redux';
import { Alert, Row, Col, Panel, Button } from 'react-bootstrap';
import * as actions from '../actions/PlanOrderActions';
import { checkIfOrderIsArchived } from './../../../OrdersActions';
import { Translate } from '../../../../../shared/LanguageService';
import { IAnnotationViewModel, ISelect } from '../Entities';
import { IPlanOrder } from './Entities';
import NewPlanOrder from './NewPlanOrder';
import DeliveredPlanOrder from './DeliveredPlanOrder';
import * as ArchiveStatus from '../../../../../shared/ArchiveStatus';
import { handleError } from '../../../../../shared/ErrorCatching';
import { selectArchivedInfo } from '../../../../../store/selectors/OrderSelectors.store';
import Loader from 'react-loader';

interface IProps {
    orderId: number;
    actions: IActions;
    isInProgress: boolean;

    planOrder: IPlanOrder;
    annotation: IAnnotationViewModel;
    availableStories: ISelect[];

    deliveredPlanOrder: any;
    roomSketcherFurnishLink: any;
    archivedInfo: {
        photoIsArchived: boolean;
        photoIsPreArchived: boolean;
        planIsArchived: boolean;
        planIsPreArchived: boolean;
        archivedStatus: number;
    };
}

interface IActions {
    resetState: () => Promise<any>;
    getPlan: (planOrderId: number) => Promise<any>;
    checkIfOrderIsArchived: (planOrderId: number) => Promise<any>;
    resetPlanOrderArchiveState: (planOrderId: number) => Promise<any>;
}

interface IState {
    showOrder: boolean;
    showGetPlanOrderFilesButton: boolean;
    isLoading: boolean;
}

class PlanOrderForm extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            showOrder: false,
            showGetPlanOrderFilesButton: false,
            isLoading: false
        };

        this.resetPlanOrderArchiveState = this.resetPlanOrderArchiveState.bind(this);
    }

    componentDidMount() {
        this.props.actions
            .checkIfOrderIsArchived(this.props.orderId)
            .then(() => {
                if (
                    (!this.props.archivedInfo.planIsArchived &&
                        !this.props.archivedInfo.planIsPreArchived) ||
                    this.props.archivedInfo.archivedStatus < ArchiveStatus.ArchivedCold
                ) {
                    this.showPlanOrder();
                }

                if (
                    this.props.archivedInfo.planIsPreArchived &&
                    this.props.archivedInfo.archivedStatus < ArchiveStatus.ArchivedGlacier
                ) {
                    this.setState({ showGetPlanOrderFilesButton: true });
                }
            })
            .catch((error: any) => handleError(error));
    }

    componentWillUnmount() {
        this.props.actions.resetState();
    }

    resetPlanOrderArchiveState() {
        this.setState({
            isLoading: true
        });

        this.props.actions
            .resetPlanOrderArchiveState(this.props.orderId)
            .then(() => {
                this.setState({
                    isLoading: false
                });
                this.showPlanOrder();
            })
            .catch((error: any) => {
                this.setState({
                    isLoading: false
                });
                handleError(error);
            });
    }

    showPlanOrder = () => {
        this.setState({ isLoading: true });
        this.setState({ showOrder: true });
        this.props.actions
            .getPlan(this.props.orderId)
            .then(() => this.setState({ isLoading: false }))
            .catch((error: any) => handleError(error));
    };

    render() {
        return (
            <div>
                <Loader loaded={!this.state.isLoading} scale={2.0} />
                {this.props.planOrder &&
                    this.props.planOrder.orderState &&
                    this.props.planOrder.orderState.value === 2 && (
                        <Alert bsStyle="danger">
                            <i className="material-icons">warning</i>{' '}
                            <strong>
                                {Translate('orders/view/planOrders/broker/form/removed/strong')}
                            </strong>{' '}
                            {Translate('orders/view/planOrders/broker/form/removed/text')}{' '}
                        </Alert>
                    )}
                {!this.props.isInProgress &&
                    this.props.planOrder &&
                    this.props.planOrder.orderState &&
                    this.props.planOrder.orderState.value !== 2 && (
                        <NewPlanOrder
                            planOrder={this.props.planOrder}
                            annotation={this.props.annotation}
                            availableStories={this.props.availableStories}
                        />
                    )}
                {!this.props.isInProgress && this.props.deliveredPlanOrder && (
                    <DeliveredPlanOrder
                        planOrder={this.props.deliveredPlanOrder.deliveryFiles}
                        roomSketcherFurnishLink={
                            this.props.deliveredPlanOrder.roomSketcherFurnishLink
                        }
                    />
                )}
                {!this.state.showOrder && this.state.showGetPlanOrderFilesButton && (
                    <fieldset>
                        <Row>
                            <Col>
                                <div className="col-sm-4 nobreak-right pull-right">
                                    <Panel>
                                        <Panel.Heading>
                                            <Panel.Title>
                                                <div>
                                                    {Translate(
                                                        'view-order/admin-planorder/show-planorder-info/panel/header'
                                                    )}
                                                </div>
                                            </Panel.Title>
                                        </Panel.Heading>

                                        <Panel.Body className="info-blue">
                                            <div>
                                                {Translate(
                                                    'view-order/admin-planorder/show-planorder-info/panel/text'
                                                )}
                                                <br />
                                                <Button
                                                    bsStyle="success"
                                                    onClick={this.showPlanOrder}
                                                >
                                                    {Translate(
                                                        'view-order/admin-planorder/show-planorder-info/panel/button-label/retrieve-order-info'
                                                    )}
                                                </Button>

                                                <Button
                                                    bsStyle="warning"
                                                    className="right"
                                                    onClick={this.resetPlanOrderArchiveState}
                                                >
                                                    {Translate(
                                                        'view-order/admin-planorder/show-planorder-info/panel/button-label/reset-order-info'
                                                    )}
                                                </Button>
                                            </div>
                                        </Panel.Body>
                                    </Panel>
                                </div>
                            </Col>
                        </Row>
                    </fieldset>
                )}
                {this.props.isInProgress && <div>{Translate('order/plan/in-progress')}</div>}
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        planOrder: state.viewPlanOrder.planOrder,
        availableStories: state.viewPlanOrder.availableStories,
        annotation: state.viewPlanOrder.annotation,
        isInProgress: state.viewPlanOrder.isInProgress,
        deliveredPlanOrder: state.viewPlanOrder.deliveredPlanOrder,
        archivedInfo: selectArchivedInfo(state)
    };
}

function mapDispatchToProps(dispatch: any): { actions: IActions } {
    return {
        actions: {
            resetState: () => dispatch(actions.resetState()),
            getPlan: (planOrderId: number) => dispatch(actions.getPlanOrder(planOrderId)),
            checkIfOrderIsArchived: (orderId: number) => dispatch(checkIfOrderIsArchived(orderId)),
            resetPlanOrderArchiveState: (planOrderId: number) =>
                dispatch(actions.resetPlanOrderArchiveState(planOrderId))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanOrderForm);
